import { render, staticRenderFns } from "./village.vue?vue&type=template&id=63d9d151"
import script from "./village.vue?vue&type=script&lang=js"
export * from "./village.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports